export enum MealPlan {
  ROOM_ONLY = 'ROOM_ONLY',
  HALF_BOARD = 'HALF_BOARD',
}
